module.exports = __webpack_public_path__ + "static/media/YM72_4.f8b2be8a.jpg";